export const DIRECTIONAL_PREFIX = ['north', 'east', 'south', 'west', 'northeast', 'northwest', 'southeast', 'southwest', 'n', 'e', 's', 'w', 'ne', 'nw', 'se', 'sw'];
